import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PromoCode } from '../../models/promocode.model';

interface PromoCodeState {
    promoCodes: PromoCode[];
    currentPromoCode: PromoCode | null;
    loading: boolean;
    emailLoading: boolean;
}

const initialState: PromoCodeState = {
    promoCodes: [],
    currentPromoCode: null,
    loading: false,
    emailLoading: false,
};

const promocodeSlice = createSlice({
    name: 'promocode',
    initialState,
    reducers: {
        getAllPromoCodes: (state) => {
            state.loading = true;
        },
        getAllPromoCodesSuccess: (state, action: PayloadAction<PromoCode[]>) => {
            state.loading = false;
            state.promoCodes = action.payload;
        },
        getAllPromoCodesFailed: (state) => {
            state.loading = false;
        },
        createPromoCode: (state) => {
            state.loading = true;
        },
        createPromoCodeSuccess: (state, action: PayloadAction<PromoCode>) => {
            state.loading = false;
            state.promoCodes = [action.payload, ...state.promoCodes];
            state.currentPromoCode = action.payload;
        },
        createPromoCodeFailed: (state) => {
            state.loading = false;
        },
        updatePromoCode: (state) => {
            state.loading = true;
        },
        updatePromoCodeSuccess: (state, action: PayloadAction<PromoCode>) => {
            state.loading = false;
            state.promoCodes = state.promoCodes.map(promoCode =>
                promoCode._id === action.payload._id ? action.payload : promoCode
            );
            state.currentPromoCode = action.payload;
        },
        updatePromoCodeFailed: (state) => {
            state.loading = false;
        },
        deletePromoCode: (state) => {
            state.loading = true;
        },
        deletePromoCodeSuccess: (state, action: PayloadAction<PromoCode>) => {
            state.loading = false;
            state.promoCodes = state.promoCodes.filter(promoCode => promoCode._id !== action.payload._id);
            state.currentPromoCode = null;
        },
        deletePromoCodeFailed: (state) => {
            state.loading = false;
        },
        emailPromoCode: (state) => {
            state.emailLoading = true;
        },
        emailPromoCodeSuccess: (state) => {
            state.emailLoading = false;
        },
        emailPromoCodeFailed: (state) => {
            state.emailLoading = false;
        },
    },
});

export const {
    getAllPromoCodes,
    getAllPromoCodesSuccess,
    getAllPromoCodesFailed,
    createPromoCode,
    createPromoCodeSuccess,
    createPromoCodeFailed,
    updatePromoCode,
    updatePromoCodeSuccess,
    updatePromoCodeFailed,
    deletePromoCode,
    deletePromoCodeSuccess,
    deletePromoCodeFailed,
    emailPromoCode,
    emailPromoCodeSuccess,
    emailPromoCodeFailed,
} = promocodeSlice.actions;

export default promocodeSlice.reducer;
